import { render, staticRenderFns } from "./WhatsappCampanhaList.vue?vue&type=template&id=5d1fb88c"
import script from "./WhatsappCampanhaList.vue?vue&type=script&lang=js"
export * from "./WhatsappCampanhaList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappCampanhaList.vue?vue&type=style&index=0&id=5d1fb88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports